// 02.7-settings.md paso b -- relocación de datos puros desde WhatsPanel.jsx (692 líneas
// operativas, sin lógica, la mayor contribución individual al tamaño de ese archivo). Cero
// cambio de contenido, solo movido.
export const semanticTagsMap = {
  "meet": {
    "label": "Meet",
    "color": "#10b981",
    "icon": "🤝",
    "words": [
      "meet",
      "meeting",
      "reunión",
      "junta",
      "cita",
      "sesión",
      "encuentro",
      "vernos",
      "nos vemos",
      "hay que vernos",
      "podemos vernos",
      "cuándo nos vemos",
      "dónde nos vemos",
      "quiero verte",
      "te veo",
      "nos encontramos",
      "encontrarnos",
      "juntarnos",
      "reunirnos",
      "podemos reunirnos",
      "hay que reunirnos",
      "nos juntamos",
      "nos reunimos",
      "platicamos en persona",
      "hablar en persona",
      "verlo en persona",
      "pasar a verte",
      "voy a verte",
      "te visito",
      "visitarte",
      "agendar",
      "agendamos",
      "agenda",
      "programar",
      "programamos",
      "coordinamos",
      "coordinarnos",
      "cuadramos",
      "apartar",
      "reservar",
      "tienes disponibilidad",
      "estás disponible",
      "cuándo puedes",
      "cuándo podrías",
      "qué día puedes",
      "qué hora puedes",
      "te queda bien",
      "te funciona",
      "tienes tiempo",
      "tienes un espacio",
      "qué horario tienes",
      "qué horario tienes libre",
      "mañana",
      "pasado mañana",
      "hoy",
      "esta semana",
      "próxima semana",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
      "domingo",
      "en la mañana",
      "por la mañana",
      "en la tarde",
      "por la tarde",
      "en la noche",
      "a las",
      "temprano",
      "más tarde",
      "al rato",
      "en un rato",
      "quedamos",
      "quedamos mañana",
      "quedamos a las",
      "ahí nos vemos",
      "te veo allá",
      "nos vemos ahí",
      "en la oficina",
      "en tu oficina",
      "en mi oficina",
      "en el despacho",
      "en el café",
      "en el restaurante",
      "en el hotel",
      "en el cowork"
    ]
  },
  "call": {
    "label": "Call",
    "color": "#3b82f6",
    "icon": "📞",
    "words": [
      "llamada",
      "llamar",
      "llamarte",
      "llámame",
      "te llamo",
      "me llamas",
      "nos llamamos",
      "hablamos",
      "podemos hablar",
      "hay que hablar",
      "platicamos",
      "podemos platicar",
      "márcame",
      "te marco",
      "marcamos",
      "llamada rápida",
      "hacemos una llamada",
      "hacemos llamada",
      "llamada por teléfono",
      "videollamada",
      "video llamada",
      "hacemos videollamada",
      "videoconferencia",
      "call",
      "hacemos call",
      "meeting online",
      "zoom",
      "hacemos zoom",
      "google meet",
      "hacemos meet",
      "teams",
      "conectarnos",
      "nos conectamos",
      "te conectas",
      "conexión",
      "pásame el link",
      "mándame el link",
      "comparte el enlace",
      "te mando el link",
      "te paso el link",
      "cuándo puedes hablar",
      "puedes hablar",
      "tienes tiempo para hablar",
      "estás disponible",
      "a qué hora puedes",
      "te marco mañana",
      "te llamo mañana",
      "hablamos mañana",
      "hablamos al rato",
      "te marco al rato",
      "cinco minutos",
      "10 minutos",
      "llamada rápida"
    ]
  },
  "task": {
    "label": "Task",
    "color": "#f59e0b",
    "icon": "📋",
    "words": [
      "tarea",
      "pendiente",
      "pendientes",
      "hacer",
      "hay que hacer",
      "tenemos que hacer",
      "tienes que hacer",
      "necesito que hagas",
      "necesito hacer",
      "encárgate",
      "encargarte",
      "me encargo",
      "te encargas",
      "asignar",
      "asignarte",
      "responsable",
      "responsabilidad",
      "pendiente de",
      "falta",
      "falta hacer",
      "falta terminar",
      "terminar",
      "completar",
      "preparar",
      "desarrollar",
      "construir",
      "crear",
      "diseñar",
      "revisar",
      "verificar",
      "validar",
      "corregir",
      "modificar",
      "cambiar",
      "actualizar",
      "investigar",
      "buscar",
      "conseguir",
      "cotizar",
      "comprar",
      "pagar",
      "enviar",
      "mandar",
      "entregar",
      "subir",
      "descargar",
      "compartir",
      "solicitar",
      "pedir",
      "hablar con",
      "contactar",
      "llamar a",
      "escribir a",
      "responder",
      "contestar",
      "confirmar",
      "aprobar",
      "autorizar",
      "firmar",
      "documentar",
      "agendar",
      "programar",
      "coordinar",
      "resolver",
      "solucionar",
      "implementar",
      "integrar",
      "instalar",
      "configurar",
      "probar",
      "testear",
      "publicar",
      "presentar",
      "darle seguimiento",
      "seguimiento",
      "recuérdame",
      "recordar",
      "no se te olvide",
      "acuérdate",
      "para hoy",
      "para mañana",
      "esta semana",
      "antes de",
      "fecha límite",
      "urgente",
      "prioridad",
      "importante",
      "listo para",
      "necesito esto",
      "quedamos en",
      "compromiso",
      "te envio",
      "te lo envio",
      "te lo envia",
      "te lo enviamos",
      "enviame",
      "envialo",
      "respondele",
      "habla con",
      "mandale",
      "has"
    ]
  },
  "location": {
    "label": "Location",
    "color": "#ef4444",
    "icon": "📍",
    "words": [
      "ubicación",
      "location",
      "dirección",
      "domicilio",
      "dónde",
      "dónde estás",
      "dónde andas",
      "dónde es",
      "dónde queda",
      "dónde nos vemos",
      "dónde nos encontramos",
      "dónde quedamos",
      "mándame la ubicación",
      "manda ubicación",
      "pásame la ubicación",
      "pasa ubicación",
      "comparte ubicación",
      "compartir ubicación",
      "envíame la ubicación",
      "te mando ubicación",
      "te paso ubicación",
      "te comparto ubicación",
      "mándame dirección",
      "pásame la dirección",
      "comparte la dirección",
      "envíame la dirección",
      "mapa",
      "maps",
      "google maps",
      "link de maps",
      "pin",
      "mándame el pin",
      "pásame el pin",
      "punto",
      "punto de encuentro",
      "lugar",
      "sitio",
      "oficina",
      "oficinas",
      "despacho",
      "casa",
      "restaurante",
      "café",
      "hotel",
      "cowork",
      "sucursal",
      "tienda",
      "bodega",
      "almacén",
      "planta",
      "aeropuerto",
      "terminal",
      "estacionamiento",
      "recepción",
      "entrada",
      "acceso",
      "puerta",
      "llego",
      "llegar",
      "cómo llego",
      "cómo llegar",
      "voy para allá",
      "voy en camino",
      "estoy en camino",
      "ya llegué",
      "estoy aquí",
      "estoy afuera",
      "estoy cerca",
      "paso por ti",
      "ven para acá",
      "nos vemos ahí",
      "te veo ahí"
    ]
  },
  "delivery": {
    "label": "Delivery",
    "color": "#8b5cf6",
    "icon": "📦",
    "words": [
      "entrega",
      "entregar",
      "entregarte",
      "entregarme",
      "te entrego",
      "me entregas",
      "entrega pendiente",
      "fecha de entrega",
      "cuándo entregas",
      "cuándo llega",
      "llevar",
      "llevarte",
      "te llevo",
      "llevarlo",
      "traer",
      "traerte",
      "tráeme",
      "recoger",
      "recojo",
      "recoges",
      "recogerlo",
      "recogerla",
      "pasar por",
      "paso por",
      "pasan por",
      "recoger documentos",
      "entregar documentos",
      "documentos",
      "papeles",
      "contrato",
      "firma",
      "paquete",
      "pedido",
      "mercancía",
      "producto",
      "equipo",
      "material",
      "envío",
      "enviar",
      "mandar",
      "mensajería",
      "mensajero",
      "paquetería",
      "recibir",
      "recibes",
      "recepción",
      "te lo dejo",
      "me lo dejas",
      "dejar",
      "dejarte",
      "dejarlo",
      "dejarla",
      "voy a dejar",
      "paso a dejar",
      "mañana paso",
      "voy para allá",
      "en la oficina",
      "en recepción",
      "mándame la ubicación",
      "pásame la dirección",
      "dónde lo entrego",
      "dónde recojo",
      "quién recibe",
      "te lo mando"
    ]
  },
  "reminder": {
    "label": "Reminder",
    "color": "#f97316",
    "icon": "⏰",
    "words": [
      "recordar",
      "recuérdame",
      "recuérdale",
      "acuérdate",
      "recordarles",
      "olvide",
      "olvides",
      "pendiente",
      "reminder",
      "aviso",
      "recuérdame mañana",
      "recuérdame que",
      "recuérdame esto",
      "recuérdale a",
      "no se me olvide",
      "no se te olvide",
      "que no se nos olvide",
      "acuérdate de",
      "acuérdame que",
      "avísame mañana",
      "avísame cuando",
      "recuérdamelo después",
      "me recuerdas",
      "recuerda"
    ]
  },
  "follow_up": {
    "label": "Follow Up",
    "color": "#06b6d4",
    "icon": "🔄",
    "words": [
      "seguimiento",
      "pendiente",
      "revisar",
      "verificar",
      "preguntar",
      "insistir",
      "contactar",
      "respuesta",
      "contestación",
      "avance",
      "estatus",
      "status",
      "dale seguimiento",
      "dar seguimiento",
      "hay que darle seguimiento",
      "quedamos pendientes",
      "sigo pendiente",
      "estamos pendientes",
      "pregúntale mañana",
      "vuelve a preguntarle",
      "vuelve a escribirle",
      "insiste mañana",
      "revisa cómo va",
      "revisa el avance",
      "pregunta qué pasó",
      "todavía no responde",
      "no me ha contestado",
      "estamos esperando respuesta"
    ]
  },
  "deadline": {
    "label": "Deadline",
    "color": "#eab308",
    "icon": "⏳",
    "words": [
      "fecha",
      "límite",
      "deadline",
      "máximo",
      "antes",
      "entrega",
      "vence",
      "vencimiento",
      "urgente",
      "hoy",
      "mañana",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "para hoy",
      "para mañana",
      "para el viernes",
      "antes del viernes",
      "antes de mañana",
      "máximo mañana",
      "máximo el lunes",
      "fecha límite",
      "fecha de entrega",
      "tiene que estar listo",
      "necesito que esté listo",
      "debe quedar listo",
      "vence mañana",
      "se entrega mañana"
    ]
  },
  "document": {
    "label": "Document",
    "color": "#6366f1",
    "icon": "📄",
    "words": [
      "mándame el documento",
      "pásame el documento",
      "comparte el documento",
      "mándame el pdf",
      "pásame el pdf",
      "mándame el archivo",
      "pásame el archivo",
      "comparte el archivo",
      "súbelo al drive",
      "dónde está el documento",
      "tienes el contrato",
      "busca el archivo",
      "adjunta el documento",
      "documento",
      "documentos",
      "archivo",
      "archivos",
      "pdf",
      "excel",
      "word",
      "presentación",
      "contrato",
      "propuesta",
      "cotización",
      "reporte",
      "informe",
      "carpeta",
      "drive",
      "adjunto"
    ]
  },
  "payment": {
    "label": "Payment",
    "color": "#14b8a6",
    "icon": "💰",
    "words": [
      "pago",
      "pagar",
      "pagado",
      "transferencia",
      "transferir",
      "depósito",
      "depositar",
      "dinero",
      "monto",
      "cuenta",
      "clabe",
      "banco",
      "tarjeta",
      "factura",
      "cobrar",
      "cobro",
      "hay que pagar",
      "falta pagar",
      "ya pagué",
      "ya está pagado",
      "te pago mañana",
      "te transfiero",
      "hago la transferencia",
      "mándame la cuenta",
      "pásame la cuenta",
      "mándame la clabe",
      "pásame la clabe",
      "cuánto te debo",
      "cuánto hay que pagar",
      "confirma el pago",
      "confirma la transferencia"
    ]
  },
  "agreement": {
    "label": "Agreement",
    "color": "#84cc16",
    "icon": "🤝",
    "words": [
      "quedamos que",
      "acordamos que",
      "se decidió",
      "decidimos que",
      "vamos con",
      "vamos por la opción",
      "queda aprobado",
      "entonces hacemos",
      "entonces quedamos",
      "confirmado entonces",
      "estamos de acuerdo",
      "queda definido",
      "ya quedamos",
      "quedo acrodado",
      "acordamos",
      "acuerdo",
      "comprimois",
      "yo lo hago",
      "yo me encargo",
      "mañana te lo mando",
      "mañana te lo envío",
      "mañana te lo entrego",
      "hoy lo termino",
      "te lo tengo mañana",
      "queda de mi lado",
      "yo lo resuelvo",
      "déjamelo a mí"
    ]
  },
  "accounts": {
    "label": "Accounts",
    "color": "#0ea5e9",
    "icon": "💳",
    "words": [
      "cuenta",
      "deposito",
      "te envio cuenta",
      "a la empresa",
      "enviame a cuenta",
      "spei",
      "banco",
      "cuentas"
    ]
  },
  "idea": {
    "label": "Idea",
    "color": "#d946ef",
    "icon": "💡",
    "words": [
      "tengo una idea",
      "se me ocurrió",
      "qué tal si",
      "podríamos hacer",
      "podríamos agregar",
      "estaría bueno",
      "estaría padre",
      "imagina que",
      "se me ocurre que",
      "propongo que",
      "idea",
      "podriamos",
      "ocurrio",
      "que buena idea",
      "idea",
      "estaria bueno",
      "imagina",
      "se me ocurrio",
      "ocurrio",
      "y si",
      "podemos"
    ]
  }
};
